/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_Starting_ToastInputs */

const en_audio_embed_export_starting_toast = /** @type {(inputs: Audio_Embed_Export_Starting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starting audio embed export...`)
};

const fr_audio_embed_export_starting_toast = /** @type {(inputs: Audio_Embed_Export_Starting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Démarrage de l'exportation de l'intégration audio...`)
};

const de_audio_embed_export_starting_toast = /** @type {(inputs: Audio_Embed_Export_Starting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audio-Einbettungs-Export wird gestartet...`)
};

const it_audio_embed_export_starting_toast = /** @type {(inputs: Audio_Embed_Export_Starting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avvio dell'esportazione del contenuto audio incorporato...`)
};

const ru_audio_embed_export_starting_toast = /** @type {(inputs: Audio_Embed_Export_Starting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Начало экспорта встроенного аудио...`)
};

const es_audio_embed_export_starting_toast = /** @type {(inputs: Audio_Embed_Export_Starting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciando la exportación de audio incrustado...`)
};

const zh_cn2_audio_embed_export_starting_toast = /** @type {(inputs: Audio_Embed_Export_Starting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开始音频嵌入导出...`)
};

const ja_audio_embed_export_starting_toast = /** @type {(inputs: Audio_Embed_Export_Starting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音声埋め込みのエクスポートを開始しています...`)
};

const hi_audio_embed_export_starting_toast = /** @type {(inputs: Audio_Embed_Export_Starting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑडियो एम्बेड निर्यात शुरू हो रहा है...`)
};

const pt_pt2_audio_embed_export_starting_toast = /** @type {(inputs: Audio_Embed_Export_Starting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciando a exportação de áudio incorporado...`)
};

/**
* | output |
* | --- |
* | "Starting audio embed export..." |
*
* @param {Audio_Embed_Export_Starting_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_starting_toast = /** @type {((inputs?: Audio_Embed_Export_Starting_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Starting_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_embed_export_starting_toast(inputs)
	if (locale === "de") return de_audio_embed_export_starting_toast(inputs)
	if (locale === "it") return it_audio_embed_export_starting_toast(inputs)
	if (locale === "ru") return ru_audio_embed_export_starting_toast(inputs)
	if (locale === "es") return es_audio_embed_export_starting_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_embed_export_starting_toast(inputs)
	if (locale === "ja") return ja_audio_embed_export_starting_toast(inputs)
	if (locale === "hi") return hi_audio_embed_export_starting_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_embed_export_starting_toast(inputs)
	return en_audio_embed_export_starting_toast(inputs)
});